var __jsx = React.createElement;
import React from "react";
import { useTranslations } from "next-intl";
import CustomAutocomplete from "../custom-autocomplete";
const MuscleAutocompleteInput = _ref => {
  let {
    identifier,
    label,
    onSelectOption,
    value,
    className = "",
    getOptions = () => Promise.resolve([]),
    inputLabelIcon,
    optionsIcon,
    hasErrors = false,
    errorMessage = "",
    placeholder,
    onClearValue,
    disable = false,
    customInputClass,
    dataTestId,
    onClick,
    disablePopper,
    disableLabelAnimation = false,
    disableXButton = false,
    useBorderlessStyle = false,
    groupIcon,
    groupKey
  } = _ref;
  const t = useTranslations("Shared.Autocomplete");
  return __jsx(CustomAutocomplete, {
    identifier: identifier,
    label: label,
    onSelectOption: onSelectOption,
    value: value,
    className: className,
    getOptions: getOptions,
    inputLabelIcon: inputLabelIcon,
    optionsIcon: optionsIcon,
    hasErrors: hasErrors,
    errorMessage: errorMessage,
    placeholder: placeholder,
    onClearValue: onClearValue,
    disable: disable,
    customInputClass: customInputClass,
    dataTestId: dataTestId,
    onClick: onClick,
    disablePopper: disablePopper,
    disableLabelAnimation: disableLabelAnimation,
    disableXButton: disableXButton,
    noOptionsText: t('NO_OPTIONS'),
    useBorderlessStyle: useBorderlessStyle,
    groupIcon: groupIcon,
    groupKey: groupKey
  });
};
export default MuscleAutocompleteInput;